<footer class="footer fixed-bottom bg-dark navbar-dark p-1">
    <div class="container text-light text-center d-flex justify-content-center" (click)="openBottomSheet()">
        <div class="m-2">
            <img src="/assets/logo.jpg" width="65">
        </div>
        <div class="m-2 d-flex flex-column text-left">
            <div>Do You Like My Art?</div>  
            <div>Would You Like Me To Make Something For You?</div>
            <div><span style="color:blue;cursor:pointer;text-decoration: underline;">Click</span> To Commission A Piece.</div>
        </div>
    </div>
</footer>
